<div class="container-fluid p-0" style="margin-top: 55px;">
    <div class="row mx-0">
        <div class="img-bg"></div>
        <!-- <img class="imgBg" src="assets/images/Sony Pictures rainbow_1.jpg" /> -->
    </div>
    <div class="container">
        <div class="row mx-0" style="margin-top: 2rem;">
            <div class="w-100 d-flex align-items-center flex-column">
                <h3 class="searchTitle">Title Search</h3>
                <!-- <div class="dx-field col-4 d-flex ">
                    <div class="dx-field-value w-100 title-search-block">
                        <dx-autocomplete placeholder="Search Title..." class="searchInputText" [(value)]="searchTitle"
                            [dataSource]="searchTitleResults" (onInput)="getSearchTitles($event)" [valueExpr]="'title'"
                            stylingMode="outlined" [searchTimeout]="500"
                            (onSelectionChanged)="onSelectionChanged($event)" [showDropDownButton]="true">
                            <dxi-button name="title_search" [options]="searchButton" location="before">
                            </dxi-button>
                        </dx-autocomplete>
                    </div>
                </div> -->
                <div class="dx-field col-12 col-md-4 d-flex ">
                    <div class="dx-field-value w-100 title-search-block">
                        <p-autoComplete 
                            #productSearch
                            appendTo="body"
                            [baseZIndex]="1000"
                            [(ngModel)]="selectedItem" 
                            [suggestions]="productResult"
                            [showEmptyMessage]="true"
                            emptyMessage="No project found" 
                            (completeMethod)="getSearchTitles($event)"
                            field="title"
                            [minLength]="2"
                            styleClass="searchInputText"
                            inputStyleClass="product-search-input"
                            placeholder="Search Title/AKA"
                            (onSelect)="onSelectionChanged($event)"
                            [dropdown]="true"
              dropdownIcon="pi pi-search"
                            >
                        </p-autoComplete>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="recent-projects" *ngIf="recentlyViewedSearch">
            <h4 class="project-title">Recently Viewed Projects</h4>
            <div class="recent-projects-body">
                <a class="btn project-items no-underline text-center" [class.ml-0]="(ind == 0 || ind == 5)"
                    *ngFor="let project of recentlyViewedSearch; let ind=index;"
                    (click)="onSelectionChanged($event)">{{project.projectId}}</a>
            </div>
        </div> -->
         <div class="recent-projects" *ngIf="recentlyViewedSearch">
            
    <div class="recent-projects-body">
       <h4 class="project-title w-100 px-1">Recently Viewed Projects</h4>
        
        <button *ngFor="let project of recentlyViewedSearch; let ind=index;" class="btn project-items text-center" title="{{project.title}}"
        (click)="onRecentSelection(project.projectId)">{{project.title}}</button>
          
    </div>
</div>
    </div>
</div>